<template>
  <div class="container" style="padding-top: 150px">
    <div class="logo">
      <div class="title">
        <h1>墣锦环境</h1>
        <p>致力于可持续发展的未来</p>
        <p>Shaping a sustainable future</p>
      </div>
      <div class="title-pc-box">
        <p class="title-pc-p1">墣锦环境</p>
        <p class="title-pc-p2">致力于可持续发展的未来</p>
        <p class="title-pc-p3">Shaping a sustainable future</p>
      </div>
      <div class="place-ul">
        <div
            class="big"
            @click="$router.push('/main?lab=' + item.name)"
            v-for="(item, index) in List"
            :key="index"
        >
          <img :src="item.photoUrl" alt="place" class="am-place-img mtop"/>
        </div>
      </div>
    </div>
    <div style="display: flex; justify-content: center; ">
<!--      <span>海南省海口市龙华区珠江广场帝豪大厦10层</span>-->
<!--      <span>@2018Pujin Environmental Engineering(Hainan) Co.,Ltd.</span>-->
      <a href="http://beian.miit.gov.cn/"> 琼ICP备18002772号-1</a>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      List: "",
    };
  },

  created() {
    this.$axios.get("/front/getFrontCitys").then((res) => {
      this.List = res.data;
    });
  },
};
</script>
<style scoped lang="scss">
.container {
  width: 100%;
}

.logo {
  width: 100%;
  min-height: 100vh;
  margin: 0 auto;
  text-align: center;
  background-image: url("../../assets/i/door/waterbg.jpg");
  -moz-background-size: 100% 100%;
  background-size: 100% 100%;
}

.place-ul {
  display: flex;
  justify-content: center;
  width: 100%;
  padding-top: 200px;
  text-align: center;
  z-index: 999;
  flex-wrap: wrap;
}

span {
  position: absolute;
  top: 40%;
  left: 50%;
}

.mtop {
  margin: 40px;
}

.big {
  overflow: hidden;
}

.big img {
  cursor: pointer;
  transition: all 0.6s;
}

.big img:hover {
  transform: scale(1.4);
}

/*.logo-img{*/
/*padding-left: 5%;*/
/*padding-top: 5%;*/
/*}*/
.title {
  display: none;
  text-align: center;
  padding-top: 5%;
  color: #acc737;
}

.title h1 {
  font-size: 20pt;
}

.title p {
  font-size: 16pt;
}

.title-pc-p3 {
  font-size: 38px;
  color: #acc737;
}

.title-pc-p2 {
  font-size: 40px;
  color: #acc737;
  letter-spacing: 5px;
}

.title-pc-p1 {
  font-size: 80px;
  color: #acc737;
  font-weight: 800;
  letter-spacing: 10px;
}

@media only screen and (max-width: 640px) {
  .place-ul {
    margin: 0;
    padding-top: 8% !important;
  }
  /*.logo-img{*/
  /*width: 80%;*/
  /*paddin g-left: 0;*/
  /*margin: 0 auto;*/
  /*}*/
  .mtop {
    margin: 10px 0;
    width: 80%;
  }
}

@media only screen and (max-width: 1024px) {
  .logo {
    background-image: url("../../assets/i/door/waterbg.jpg") !important;
  }
  .title {
    display: block;
  }
  .title-pc-box {
    display: none;
  }
}

.title-pc-box {
  max-width: 500px;
  margin: 0 auto;
  text-align: left;
  padding-top: 140px;
}

.title-pc-p1,
.title-pc-p2,
.title-pc-p3 {
  margin: 0;
}
</style>
